export const translations = {
  tr: {
    // Navigation
    about: 'Hakkımızda',
    gallery: 'Galeri',
    menu: 'Menü',
    contact: 'İletişim',
    
    // Hero Section
    heroTitle: 'Cigani Restaurant',
    heroSubtitle: 'Sığacık\'ta Ege\'nin bereketli topraklarından ilham alan gastronomi deneyimi',
    heroDescription: 'Yalın, taze, Ege lezzetleri',
    
    // About Section
    aboutTitle: 'Hakkımızda',
    aboutText1: 'Cigani Restaurant, Sığacık\'ın kalbinde; doğallığın, sadeliğin ve lezzetin zarif bir uyumla buluştuğu bir restoran olarak doğdu. Her gün taze toplanan yerel malzemelerle hazırladığımız menümüzde, Ege\'nin köklü mutfak kültürünü çağdaş dokunuşlarla yeniden yorumluyoruz.',
    aboutText2: 'Burada her tabak, toprağa ve mevsime duyulan saygıyla hazırlanır. Geleneksel tarifler modern sunumlarla yeniden hayat bulurken, misafirlerimize sadece bir yemek değil; dingin, zarif ve samimi bir deneyim sunmayı amaçlıyoruz.',
    aboutText3: 'Cigani\'de masa paylaşılır, zaman yavaş akar. Sohbet uzar, kadehler dostluğa kalkar. Burası sadece yemek yenen değil, yaşanılan bir yerdir.',
    aboutText4: 'Gelin, soframıza katılın.',
    
    // Gallery Section
    galleryTitle: 'Galeri',
    
    // Menu Section
    menuTitle: 'Menü',
    starters: 'BAŞLARKEN',
    salads: 'SALATALAR',
    sharedHot: 'PAYLAŞIMLI SICAKLAR',
    desserts: 'BİTİRİRKEN',
    
    // Contact Section
    address: 'Adres',
    phone: 'Telefon',
    instagram: 'Instagram',
    workingHours: 'Çalışma Saatleri',
    reservation: 'Rezervasyon',
    
    // Reservation Form
    reservationTitle: 'Rezervasyon',
    name: 'Ad Soyad',
    email: 'E-posta',
    phoneNumber: 'Telefon',
    guests: 'Kişi Sayısı',
    date: 'Tarih',
    time: 'Saat',
    notes: 'Notlar',
    submit: 'Rezervasyon Yap',
    
    // Form placeholders
    namePlaceholder: 'Adınız ve soyadınız',
    emailPlaceholder: 'ornek@email.com',
    guestsPlaceholder: 'Örn: 2',
    timeSelectPlaceholder: 'Saat seçiniz',
    notesPlaceholder: 'Özel isteklerinizi buraya yazabilirsiniz...',
    
    // Contact Info
    addressValue: 'Sığacık, 128. Sk. No:22, 35460 Seferihisar/İzmir',
    instagramValue: '@cigani.sigacik',
    workingHoursValue: '17:00 - 01:00',
    
    // Time options
    timeOptions: [
      '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
      '20:00', '20:30', '21:00', '21:30', '22:00'
    ]
  },
  
  en: {
    // Navigation
    about: 'About',
    gallery: 'Gallery',
    menu: 'Menu',
    contact: 'Contact',
    
    // Hero Section
    heroTitle: 'Cigani Restaurant',
    heroSubtitle: 'A gastronomic experience inspired by the fertile lands of the Aegean in Sığacık',
    heroDescription: 'Simple, fresh, Aegean flavors',
    
    // About Section
    aboutTitle: 'About Us',
    aboutText1: 'Cigani Restaurant was born in the heart of Sığacık as a restaurant where nature, simplicity, and taste meet in elegant harmony. In our menu prepared with fresh local ingredients collected daily, we reinterpret the deep-rooted culinary culture of the Aegean with contemporary touches.',
    aboutText2: 'Here, every dish is prepared with respect for the soil and season. While traditional recipes come to life with modern presentations, we aim to offer our guests not just a meal, but a peaceful, elegant, and sincere experience.',
    aboutText3: 'At Cigani, tables are shared, time flows slowly. Conversations extend, glasses are raised to friendship. This is not just a place to eat, but a place to live.',
    aboutText4: 'Come, join our table.',
    
    // Gallery Section
    galleryTitle: 'Gallery',
    
    // Menu Section
    menuTitle: 'Menu',
    starters: 'TO START',
    salads: 'SALADS',
    sharedHot: 'SHARED HOT DISHES',
    desserts: 'TO FINISH',
    
    // Contact Section
    address: 'Address',
    phone: 'Phone',
    instagram: 'Instagram',
    workingHours: 'Working Hours',
    reservation: 'Reservation',
    
    // Reservation Form
    reservationTitle: 'Reservation',
    name: 'Full Name',
    email: 'Email',
    phoneNumber: 'Phone',
    guests: 'Number of Guests',
    date: 'Date',
    time: 'Time',
    notes: 'Notes',
    submit: 'Make Reservation',
    
    // Form placeholders
    namePlaceholder: 'Your full name',
    emailPlaceholder: 'example@email.com',
    guestsPlaceholder: 'e.g. 2',
    timeSelectPlaceholder: 'Select time',
    notesPlaceholder: 'Write your special requests here...',
    
    // Contact Info
    addressValue: 'Sığacık, 128. Sk. No:22, 35460 Seferihisar/İzmir',
    instagramValue: '@cigani.sigacik',
    workingHoursValue: '17:00 - 01:00',
    
    // Time options
    timeOptions: [
      '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
      '20:00', '20:30', '21:00', '21:30', '22:00'
    ]
  }
};

export type Language = 'tr' | 'en'; 